import { render, staticRenderFns } from "./SprayItems.vue?vue&type=template&id=8df8ed9a&scoped=true&"
import script from "./SprayItems.vue?vue&type=script&lang=js&"
export * from "./SprayItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df8ed9a",
  null
  
)

export default component.exports